<template>
    <LocationCard v-for="(location, index) in locations" :key="index" :location="location" modifier=""/>
</template>

<script>
import LocationCard from "./LocationCard";
export default {
    props: ["locations"],
    components: {
        LocationCard
    },
    mounted() {
    },
    data() {
        return {

        }
    }
}
</script>

